export const AppConfig = {
    site_name: 'Adó-TanGazdagság Bt.',
    title: 'AdóGazda',
    description: 'Számviteli szolgáltatások, adótanácsadás',
    locale: 'hu',
  };
  